import { useRestApiProvider } from "@jugl-web/rest-api";
import { skipToken } from "@reduxjs/toolkit/dist/query";

interface UseTaskInitQueryOptions {
  entityId?: string;
}

export const useTaskInitQuery = ({ entityId }: UseTaskInitQueryOptions) => {
  const { tasksApi } = useRestApiProvider();

  const { data, isLoading, isFetching, isError, refetch } =
    tasksApi.useTaskInitQuery(entityId ? { entityId } : skipToken, {
      refetchOnMountOrArgChange: false,
    });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};
